import { connect } from 'react-redux';

import { selectActiveVenue, selectUserInfo } from 'selectors/general';

import { goToTab as goToTabAction } from '../../ManageServices.saga';
import { selectServices } from '../../Services/Services.selectors';
import { createPractitioner as createPractitionerAction } from '../Practitioners.saga';
import { messages } from '../Practitioners.messages';
import PractitionerForm from './PractitionerForm';

export const mapStateToProps = state => {
  const { countryCodeShort, venueId } = selectActiveVenue(state);

  return {
    countryCodeShort,
    venueId,
    user: selectUserInfo(state),
    title: messages.form.addPractitioner,
    servicesList: selectServices(state),
    isLoaded: true,
    defaultValues: {},
  };
};

const mapDispatchToProps = {
  createPractitioner: createPractitionerAction,
  goToTab: goToTabAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { createPractitioner, goToTab } = dispatchProps;

  return {
    ...stateProps,
    handleCancel: () => goToTab(),
    handleSubmit: createPractitioner,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(PractitionerForm);
